export function hasVisibleRichTextContent(html: string): boolean {
  let isInsideTag = false;

  for (const character of html) {
    if (character === '<') {
      isInsideTag = true;
      continue;
    }

    if (character === '>') {
      isInsideTag = false;
      continue;
    }

    if (!isInsideTag && !isRichTextWhitespace(character)) {
      return true;
    }
  }

  return false;
}

function isRichTextWhitespace(character: string): boolean {
  return character === ' '
    || character === '\t'
    || character === '\n'
    || character === '\r'
    || character === '\f'
    || character === '\v';
}
